import ReactGA4 from 'react-ga4';
const InitializeGoogleAnalytics = () => {
  ReactGA4.initialize('G-YDW7FWL298');
};

const TrackGoogleAnalyticsEvent = (
  category: string,
  action: string
) => {
  ReactGA4.event({
    category,
    action
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
